import { OpenFeature } from '@openfeature/react-sdk';
import { LaunchDarklyClientProvider } from '@openfeature/launchdarkly-client-provider';

/**
 * Sets up OpenFeature with LaunchDarkly provider
 */
export function setupOpenFeature(): void {
  const launchDarklyClientId = process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID;
  if (!launchDarklyClientId) {
    throw new Error(
      "Environment variable 'REACT_APP_LAUNCHDARKLY_CLIENT_ID' is required but not set.",
    );
  }

  const launchDarklyOptions = {
    initializationTimeout: 5, // 5 seconds - max recommended by LaunchDarkly
    // NOTE: disable streaming as it seems to trigger issues like
    //       Error: CORS request did not succeed
    //       which lead to not receiving the flag at all and not rendering
    //       the desired content behind the Feature Flag
    // https://support.launchdarkly.com/hc/en-us/articles/14117988876827-Error-CORS-request-did-not-succeed-on-Firefox
    streaming: false, // Enable streaming for real-time flag updates
  };

  OpenFeature.setProvider(
    new LaunchDarklyClientProvider(launchDarklyClientId, launchDarklyOptions),
  );
}
